<template>
    <div>
        <apexchart type="bar" :height="height" :options="chartOptions" :series="seriesInfo.series"></apexchart>
    </div>
    
</template>

<script>
export default {
    props: ['seriesInfo', 'facebookPageNameArray', 'height'],
    data: () => ({
        series: [{
            data:[]
        }],
        chartOptions: {
            chart: {
                type: 'bar',
            },
            colors: ['#cf287f', '#5977ac', '#50c0c2'],
            plotOptions: {
                bar: {
                    distributed: true,
                    borderRadius: 4,
                    horizontal: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: [],
            },
        },
    }),
    created() {
        this.chartOptions.xaxis.categories = this.facebookPageNameArray
    }
}
</script>